<div class="container-fluid">

  <div class="header-container">
    <div class="header-container mt-2">
      <button class="iso-link-button" [ngClass]="{'iso-selected': tab===0}"
        (click)="changeTab(0)">{{'bikeshop.plugins.widget.booking-widget' | translate}}</button>
      <button [ngClass]="{'iso-selected': tab===1}" class="iso-link-button" *ngIf="hasFittings"
        (click)="changeTab(1)">{{'bikeshop.plugins.widget.fittings-widget' | translate}}</button>
      <button [ngClass]="{'iso-selected': tab===2}" class="iso-link-button" *ngIf="hasCollectionsOrDropOffs"
        (click)="changeTab(2)">{{'bikeshop.plugins.widget.collections-widget' | translate}}</button>
      <button [ngClass]="{'iso-selected': tab===3}" class="iso-link-button" *ngIf="linkedToFranchise"
        (click)="changeTab(3)">{{'bikeshop.plugins.widget.multistore-widget' | translate}}</button>
      <button [ngClass]="{'iso-selected': tab===4}" class="iso-link-button" *ngIf="hasFittings && linkedToFranchise"
        (click)="changeTab(4)">{{'bikeshop.plugins.widget.multistore-fittings-widget' | translate}}</button>


    </div>

  </div>
  <!-- Show the settings for single store widgets -->
  <div class="content" *ngIf="tab < 3">

    <div class="row">
      <div class="col-md-12">

        <!--begin:general-->
        <div class="row margin-top-8">
          <div class="col-md-4 label bold">
            {{'bikeshop.shop_setup.header.general' | translate}}:
          </div>
        </div>

        <div class="row margin-top-8">
          <div class="col-md-4 label" [ngClass]="{'red' : workshopWidgetNextServiceBufferTime < 1}">
            {{'bikeshop.plugins.widget.workshop_booking_buffer_time' | translate}}:
          </div>
          <div class="col-md-1">
            <div class="ui-inputgroup">
              <input pInputText placeholder="" [ngClass]="{'invalid' : workshopWidgetNextServiceBufferTime < 1}"
                type="number" min="1" (ngModelChange)="validateBufferTime($event)"
                [(ngModel)]="workshopWidgetNextServiceBufferTime" />
            </div>
          </div>
          <div class="col-md-7 label">
            <small
              innerHTML="{{'bikeshop.plugins.widget.workshop_booking_buffer_time_description' | translate}}"></small>
          </div>
        </div>

        <div class="row margin-top-8">
          <div class="col-md-4 label">
            {{'bikeshop.plugins.widget.language' | translate}}:
          </div>
          <div class="col-md-8">
            <p-dropdown [options]="languages" [(ngModel)]="language"
              placeholder="{{'bikeshop.plugins.widget.select-language' | translate}}"></p-dropdown>
          </div>
        </div>

        <div *ngIf="(tab===0 || tab===2) && selectedServiceGroups.length == 0">
          <div class="row margin-top-8">
            <div class="col-md-4 label">
              {{'bikeshop.menu.service_types' | translate}}:
            </div>
            <div class="col-md-8">
              <p-multiSelect #serviceTypeDropDown [options]="serviceTypes" [(ngModel)]="selectedServiceTypes"
                [filter]="true" [showHeader]="true" filterBy="search,reverseSearch" scrollHeight="380px"
                [resetFilterOnHide]="true" autofocus="true" [showToggleAll]="false">
              </p-multiSelect>
            </div>
          </div>

          <div class="row">
            <div class="col-md-4 label">
            </div>
            <div class="col-md-8">
              <div class="explanation"
                innerHTML="{{'bikeshop.plugins.widget.pre-select-services-description' | translate}}"></div>
            </div>
          </div>
        </div>

        <div *ngIf="selectedServiceTypes.length == 0">
          <div class="row margin-top-8">
            <div class="col-md-4 label">
              {{'general.headers.services' | translate}} {{'bikeshop.shop_rides.group_name' | translate}}:
            </div>
            <div class="col-md-8">
              <p-multiSelect #serviceTypeDropDown [options]="serviceGroups" [(ngModel)]="selectedServiceGroups"
                [filter]="true" [showHeader]="true" filterBy="search,reverseSearch" scrollHeight="380px"
                [resetFilterOnHide]="true" autofocus="true" [showToggleAll]="false">
              </p-multiSelect>
            </div>
          </div>

          <div class="row">
            <div class="col-md-4 label">
            </div>
            <div class="col-md-8">
              <div class="explanation"
                innerHTML="{{'bikeshop.plugins.widget.pre-select-group-description' | translate}}"></div>
            </div>
          </div>
        </div>

        <div class="row margin-top-8">
          <div class="col-md-4 label">
            {{'bikeshop.plugins.widget.additionalinformation' | translate}}:
          </div>
          <div class="col-md-8">
            <div>
              <quill-editor #additionalInfoEditor [(ngModel)]="additionalInformation" [modules]="modules" format="html"
                (onEditorCreated)="onQuillEditorCreated($event)">
              </quill-editor>
            </div>
          </div>
        </div>
        <div class="row magin-top-8">
          <div class="col-md-4 label">
          </div>
          <div class="col-md-8">
            <div class="explanation"
              innerHTML="{{'bikeshop.plugins.widget.additionalinformation_placeholder' | translate}}"></div>
          </div>
        </div>

        <div class="row margin-top-8">
          <div class="col-md-4 label">
            {{'bikeshop.plugins.widget.paymentinformation' | translate}}:
          </div>
          <div class="col-md-8">
            <div>
              <quill-editor #paymentInfoEditor [(ngModel)]="paymentInformation" [modules]="modules" format="html"
                (onEditorCreated)="onQuillEditorCreated($event)">
              </quill-editor>
            </div>
          </div>
        </div>
        <div class="row magin-top-8">
          <div class="col-md-4 label">
          </div>
          <div class="col-md-8">
            <div class="explanation"
              innerHTML="{{'bikeshop.plugins.widget.paymentinformation_placeholder' | translate}}"></div>
          </div>
        </div>
        <!--end:general-->
        <!--begin:other settings-->
        <div class="row margin-top-8">
          <div class="col-md-4 label bold">
            {{'bikeshop.menu.other_settings' | translate}}
          </div>
        </div>

        <div class="row margin-top-8">
          <div class="col-md-4 label">
            {{'bikeshop.plugins.widget.show_prices' | translate}}:
          </div>
          <div class="col-md-8">
            <div class="p-inputgroup">
              <p-inputSwitch [(ngModel)]="showPrices"></p-inputSwitch>
              <small style="
                  margin-left: 8px;
                  margin-top: auto;
                  margin-bottom: auto;
                ">
              </small>
            </div>
          </div>
        </div>


        <div class="row margin-top-8">
          <div class="col-md-4 label">
            {{'bikeshop.plugins.widget.show_hear_about' | translate}}:
          </div>
          <div class="col-md-8">
            <div class="p-inputgroup">
              <p-inputSwitch [(ngModel)]="showHearAbout"></p-inputSwitch>
              <small style="
                  margin-left: 8px;
                  margin-top: auto;
                  margin-bottom: auto;
                ">
              </small>
            </div>
          </div>
        </div>

        <div class="row margin-top-8">
          <div class="col-md-4 label">
            {{'bikeshop.plugins.widget.show_coupons' | translate}}:
          </div>
          <div class="col-md-8">
            <div class="p-inputgroup">
              <p-inputSwitch [(ngModel)]="showCoupons"></p-inputSwitch>
              <small style="
                  margin-left: 8px;
                  margin-top: auto;
                  margin-bottom: auto;
                ">
              </small>
            </div>
          </div>
        </div>

        <div class="row margin-top-8">
          <div class="col-md-4 label">
            {{'bikeshop.plugins.widget.show_preapproved_amount' | translate}}:
          </div>
          <div class="col-md-8">
            <div class="p-inputgroup">
              <p-inputSwitch [(ngModel)]="showPreApprovedAmount"></p-inputSwitch>
              <small style="
                  margin-left: 8px;
                  margin-top: auto;
                  margin-bottom: auto;
                ">
              </small>
            </div>
          </div>
        </div>

        <div class="row margin-top-8" *ngIf="hasFittings && onFittingTab">
          <div class="col-md-4 label">
            Require item when booking in a fitting:
          </div>
          <div class="col-md-8">
            <div class="p-inputgroup">
              <p-inputSwitch [(ngModel)]="requireItemOnFitting"></p-inputSwitch>
              <small style="
                  margin-left: 8px;
                  margin-top: auto;
                  margin-bottom: auto;
                ">
              </small>
            </div>
          </div>
        </div>
        <div class="row margin-top-8" *ngIf="!requireItemOnFitting && hasFittings && onFittingTab">
          <div class="col-md-4 label">
            Default item name to use for a fitting:
          </div>
          <div class="col-md-8">
            <div class="p-inputgroup">
              <div class="ui-inputgroup">
                <input pInputText placeholder="" maxlength="12" [(ngModel)]="defaultFittingItemName" />
              </div>
            </div>
          </div>
        </div>

        <!--end:other settings-->
        <!--begin:gtm settings-->
        <div class="row margin-top-8">
          <div class="col-md-4 label bold">
            {{'bikeshop.rentals.configuration.google_tag_manager' | translate}}
          </div>
        </div>

        <div class="row margin-top-8">
          <div class="col-md-4 label">
            {{'bikeshop.rentals.configuration.google_tag_manager_id' | translate}}:
          </div>
          <div class="col-md-8">
            <div class="ui-inputgroup">
              <input pInputText placeholder="GTM-XXXXXXX" maxlength="12" [(ngModel)]="widgetTrackingGTMCode" />
            </div>
          </div>
        </div>
        <!--end:gtm settings-->
        <!--begin:facebook pixel settings-->
        <div class="row margin-top-8">
          <div class="col-md-4 label bold">
            {{'bikeshop.rentals.configuration.facebook_pixel_manager' | translate}}
          </div>
        </div>

        <div class="row margin-top-8">
          <div class="col-md-4 label">
            {{'bikeshop.rentals.configuration.facebook_pixel_manager_code' | translate}}:
          </div>
          <div class="col-md-8">
            <div class="ui-inputgroup">
              <input pInputText placeholder="XXXXXXX" [(ngModel)]="widgetFacebookPixel" />
            </div>
          </div>
        </div>
        <!--end:facebook pixel settings-->
        <!--begin:styling-->
        <div *ngIf="!usesFranchiseTheme">
          <div class="row margin-top-8">
            <div class="col-md-4 label bold">
              {{'bikeshop.plugins.widget.widget_theme_configuration' | translate}}:
            </div>
          </div>

          <div class="row margin-top-8">
            <div class="col-md-4 label">
              {{'bikeshop.plugins.widget.widget_theme_primary_color' | translate}}:
            </div>
            <div class="col-md-8">
              <div style="display: flex;">
                <div class="color-picker-custom" [ngClass]="{'not-set': !primaryColor}"
                  [ngStyle]="{ 'background-color' : primaryColor }" [colorPicker]="primaryColor"
                  (colorPickerChange)="updateColor($event, 'primaryColor')" cpOutputFormat="hex"
                  cpAlphaChannel="disabled">
                </div>
              </div>
            </div>
          </div>

          <div class="row margin-top-8">
            <div class="col-md-4 label">
              {{'bikeshop.plugins.widget.widget_theme_primary_textcolor' | translate}}:
            </div>
            <div class="col-md-8">
              <div style="display: flex;">
                <div class="color-picker-custom" [ngClass]="{'not-set': !primaryTextColor}"
                  [ngStyle]="{ 'background-color' : primaryTextColor }" [colorPicker]="primaryTextColor"
                  (colorPickerChange)="updateColor($event, 'primaryTextColor')" cpOutputFormat="hex"
                  cpAlphaChannel="disabled">
                </div>
              </div>
            </div>
          </div>

          <div class="row margin-top-8">
            <div class="col-md-4 label">
              {{'bikeshop.plugins.widget.widget_theme_secondary_textcolor' | translate}}:
            </div>
            <div class="col-md-8">
              <div style="display: flex;">
                <div class="color-picker-custom" [ngClass]="{'not-set': !secondaryTextColor}"
                  [ngStyle]="{ 'background-color' : secondaryTextColor }" [colorPicker]="secondaryTextColor"
                  (colorPickerChange)="updateColor($event, 'secondaryTextColor')" cpOutputFormat="hex"
                  cpAlphaChannel="disabled">
                </div>
              </div>
            </div>
          </div>

          <div class="row margin-top-8">
            <div class="col-md-4 label">
              {{'bikeshop.plugins.widget.widget_theme_calendar_color' | translate}}:
            </div>
            <div class="col-md-8">
              <div style="display: flex;">
                <div class="color-picker-custom" [ngClass]="{'not-set': !calendarColor}"
                  [ngStyle]="{ 'background-color' : calendarColor }" [colorPicker]="calendarColor"
                  (colorPickerChange)="updateColor($event, 'calendarColor')" cpOutputFormat="hex"
                  cpAlphaChannel="disabled">
                </div>
              </div>
            </div>
          </div>

          <div class="row margin-top-8">
            <div class="col-md-4 label">
              {{'bikeshop.plugins.widget.widget_theme_font' | translate}}:
            </div>
            <div class="col-md-8">
              <div class="font-options">
                <div *ngFor="let font of fontOptions" (click)="updateFont(font)"
                  [ngClass]="{'selected':font.value === customFontName}" [ngStyle]="{'font-family': font.value}">
                  {{font.value}}
                </div>
              </div>

              <div class="label-custom margin-top-8" [ngStyle]="{'font-family': customFontName}">
                Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut
                labore et
                dolore magna aliqua.
              </div>
            </div>
          </div>
          <!--end:styling-->
        </div>

      </div>
    </div>

    <div class="row margin-top-16">
      <div class="col-md-9">
        <!-- <div class="page-header">
          <span class="fa fa-id-badge"></span>{{ "bikeshop.shop_ride_configuration.widget_preview" | translate }}
        </div> -->

        <div class="flex">
          <div>
            <button class="iso-round-button" (click)="saveConfig(true)" [disabled]="!isConfigValid()">Preview Widget
            </button>
          </div>
          <div style="margin-left: 16px">
            <button class="iso-round-button" (click)="copyLink()">{{'bikeshop.shop_ride_configuration.copy_link' |
              translate}}</button>
          </div>
          <div style="margin-left: 16px">
            <button class="iso-round-button" (click)="copyIFrame()">{{'bikeshop.shop_ride_configuration.copy_iframe' |
              translate}}</button>
          </div>
        </div>

      </div>
      <div class="col-md-3">
        <button type="button" class="iso-round-button full-width iso-light" [disabled]="saving || !isConfigValid()"
          (click)="saveConfig(false)">{{'bikeshop.shop_ride_configuration.save_configuration' | translate}}</button>
      </div>
    </div>

  </div>


  <!-- Show basic stuff for multistore widget, no store specific settings -->
  <div class="content" *ngIf="tab >= 3">

    <div class="row">
      <div class="col-md-12">

        <!--begin:general-->
        <div class="row margin-top-8">
          <div class="col-md-4 label bold">
            General:
          </div>
        </div>

        <div class="row margin-top-8">
          <div class="col-md-4 label">
            {{'bikeshop.plugins.widget.language' | translate}}:
          </div>
          <div class="col-md-8">
            <p-dropdown [options]="languages" [(ngModel)]="language"
              placeholder="{{'bikeshop.plugins.widget.select-language' | translate}}"></p-dropdown>
          </div>
        </div>

        <div *ngIf="selectedServiceGroups.length == 0 && tab == 3">
          <div class="row margin-top-8">
            <div class="col-md-4 label">
              {{'bikeshop.menu.service_types' | translate}}:
            </div>
            <div class="col-md-8">
              <p-multiSelect #serviceTypeDropDown [options]="serviceTypes" [(ngModel)]="selectedServiceTypes"
                [filter]="true" [showHeader]="true" filterBy="search,reverseSearch" optionValue="search"
                scrollHeight="380px" [resetFilterOnHide]="true" autofocus="true" [showToggleAll]="false">
              </p-multiSelect>
            </div>
          </div>

          <div class="row">
            <div class="col-md-4 label">
            </div>
            <div class="col-md-8">
              <div class="explanation"
                innerHTML="{{'bikeshop.plugins.widget.pre-select-services-description' | translate}}"></div>
            </div>
          </div>
        </div>

        <div *ngIf="selectedServiceTypes.length == 0">
          <div class="row margin-top-8">
            <div class="col-md-4 label">
              {{'general.headers.services' | translate}} {{'bikeshop.shop_rides.group_name' | translate}}:
            </div>
            <div class="col-md-8">
              <p-multiSelect #serviceTypeDropDown [options]="serviceGroups" [(ngModel)]="selectedServiceGroups"
                [filter]="true" [showHeader]="true" filterBy="search,reverseSearch" scrollHeight="380px"
                [resetFilterOnHide]="true" autofocus="true" [showToggleAll]="false">
              </p-multiSelect>
            </div>
          </div>

          <div class="row">
            <div class="col-md-4 label">
            </div>
            <div class="col-md-8">
              <div class="explanation"
                innerHTML="{{'bikeshop.plugins.widget.pre-select-group-description' | translate}}"></div>
            </div>
          </div>
        </div>


        <!--end:general-->




      </div>
    </div>

    <div class="row" style="margin-top: 64px;">
      <div class="col-md-9">
        <!-- <div class="page-header">
          <span class="fa fa-id-badge"></span>{{ "bikeshop.shop_ride_configuration.widget_preview" | translate }}
        </div> -->

        <div class="flex">
          <div>
            <button class="iso-round-button" (click)="showWidgetPreview()" [disabled]="!isConfigValid()">Preview Widget
            </button>
          </div>
          <div style="margin-left: 16px">
            <button class="iso-round-button" (click)="copyLink()">{{'bikeshop.shop_ride_configuration.copy_link' |
              translate}}</button>
          </div>
          <div style="margin-left: 16px">
            <button class="iso-round-button" (click)="copyIFrame()">{{'bikeshop.shop_ride_configuration.copy_iframe' |
              translate}}</button>
          </div>
        </div>

      </div>
    </div>

  </div>

</div>

<p-toast position="bottom-right" styleClass="hubtiger-toast"></p-toast>

<p-sidebar #NavSideBar [(visible)]="showPreviewWidgetPanel" position="right"
  [style]="{width:'70em', background: '#fff', 'overflow-x': 'auto'}" (onHide)="NavSideBar.destroyModal()">
  <div class="container-fluid" *ngIf="showPreviewWidgetPanel">

    <div class="row margin-top-8">
      <div class="header">
        Widget Preview
      </div>
    </div>
    <!--begin:iframe-->
    <div class="row margin-top-16">
      <div class="col-md-12 ">
        <div style="border: 1px solid transparent;border-radius: 6px;overflow: hidden;">
          <iframe *ngIf="link!=='' && !linkChanging" class="fill-content-height" [src]="link" frameborder='0'
            allow='geolocation' style='width: 100%;'></iframe>
        </div>
      </div>
    </div>
    <!--end:iframe-->

  </div>
</p-sidebar>